import { default as index727yobgAytMeta } from "/ice/pages/bindcar/index.vue?macro=true";
import { default as callCenterMo3fzSo1eoMeta } from "/ice/pages/callCenter.vue?macro=true";
import { default as indexzi6W4eStZ5Meta } from "/ice/pages/contactUs/index.vue?macro=true";
import { default as errorR3sSIjJcRVMeta } from "/ice/pages/deleteAccount/error.vue?macro=true";
import { default as index5FvTBhw6vzMeta } from "/ice/pages/deleteAccount/index.vue?macro=true";
import { default as step8mFsaFBkcEMeta } from "/ice/pages/deleteAccount/step.vue?macro=true";
import { default as successcqEYkFNzwOMeta } from "/ice/pages/deleteAccount/success.vue?macro=true";
import { default as historyDetail0R5clc93sFMeta } from "/ice/pages/protocol/historyDetail.vue?macro=true";
import { default as historyListhJdahV8bz6Meta } from "/ice/pages/protocol/historyList.vue?macro=true";
import { default as indexnjfBdLeD65Meta } from "/ice/pages/protocol/index.vue?macro=true";
import { default as pointRulesxTAVnZraL7Meta } from "/ice/pages/protocol/pointRules.vue?macro=true";
import { default as protocolListG6naI9wu7LMeta } from "/ice/pages/protocol/protocolList.vue?macro=true";
export default [
  {
    name: index727yobgAytMeta?.name ?? "bindcar",
    path: index727yobgAytMeta?.path ?? "/bindcar",
    meta: index727yobgAytMeta || {},
    alias: index727yobgAytMeta?.alias || [],
    redirect: index727yobgAytMeta?.redirect || undefined,
    component: () => import("/ice/pages/bindcar/index.vue").then(m => m.default || m)
  },
  {
    name: callCenterMo3fzSo1eoMeta?.name ?? "callCenter",
    path: callCenterMo3fzSo1eoMeta?.path ?? "/callCenter",
    meta: callCenterMo3fzSo1eoMeta || {},
    alias: callCenterMo3fzSo1eoMeta?.alias || [],
    redirect: callCenterMo3fzSo1eoMeta?.redirect || undefined,
    component: () => import("/ice/pages/callCenter.vue").then(m => m.default || m)
  },
  {
    name: indexzi6W4eStZ5Meta?.name ?? "contactUs",
    path: indexzi6W4eStZ5Meta?.path ?? "/contactUs",
    meta: indexzi6W4eStZ5Meta || {},
    alias: indexzi6W4eStZ5Meta?.alias || [],
    redirect: indexzi6W4eStZ5Meta?.redirect || undefined,
    component: () => import("/ice/pages/contactUs/index.vue").then(m => m.default || m)
  },
  {
    name: errorR3sSIjJcRVMeta?.name ?? "deleteAccount-error",
    path: errorR3sSIjJcRVMeta?.path ?? "/deleteAccount/error",
    meta: errorR3sSIjJcRVMeta || {},
    alias: errorR3sSIjJcRVMeta?.alias || [],
    redirect: errorR3sSIjJcRVMeta?.redirect || undefined,
    component: () => import("/ice/pages/deleteAccount/error.vue").then(m => m.default || m)
  },
  {
    name: index5FvTBhw6vzMeta?.name ?? "deleteAccount",
    path: index5FvTBhw6vzMeta?.path ?? "/deleteAccount",
    meta: index5FvTBhw6vzMeta || {},
    alias: index5FvTBhw6vzMeta?.alias || [],
    redirect: index5FvTBhw6vzMeta?.redirect || undefined,
    component: () => import("/ice/pages/deleteAccount/index.vue").then(m => m.default || m)
  },
  {
    name: step8mFsaFBkcEMeta?.name ?? "deleteAccount-step",
    path: step8mFsaFBkcEMeta?.path ?? "/deleteAccount/step",
    meta: step8mFsaFBkcEMeta || {},
    alias: step8mFsaFBkcEMeta?.alias || [],
    redirect: step8mFsaFBkcEMeta?.redirect || undefined,
    component: () => import("/ice/pages/deleteAccount/step.vue").then(m => m.default || m)
  },
  {
    name: successcqEYkFNzwOMeta?.name ?? "deleteAccount-success",
    path: successcqEYkFNzwOMeta?.path ?? "/deleteAccount/success",
    meta: successcqEYkFNzwOMeta || {},
    alias: successcqEYkFNzwOMeta?.alias || [],
    redirect: successcqEYkFNzwOMeta?.redirect || undefined,
    component: () => import("/ice/pages/deleteAccount/success.vue").then(m => m.default || m)
  },
  {
    name: historyDetail0R5clc93sFMeta?.name ?? "protocol-historyDetail",
    path: historyDetail0R5clc93sFMeta?.path ?? "/protocol/historyDetail",
    meta: historyDetail0R5clc93sFMeta || {},
    alias: historyDetail0R5clc93sFMeta?.alias || [],
    redirect: historyDetail0R5clc93sFMeta?.redirect || undefined,
    component: () => import("/ice/pages/protocol/historyDetail.vue").then(m => m.default || m)
  },
  {
    name: historyListhJdahV8bz6Meta?.name ?? "protocol-historyList",
    path: historyListhJdahV8bz6Meta?.path ?? "/protocol/historyList",
    meta: historyListhJdahV8bz6Meta || {},
    alias: historyListhJdahV8bz6Meta?.alias || [],
    redirect: historyListhJdahV8bz6Meta?.redirect || undefined,
    component: () => import("/ice/pages/protocol/historyList.vue").then(m => m.default || m)
  },
  {
    name: indexnjfBdLeD65Meta?.name ?? "protocol",
    path: indexnjfBdLeD65Meta?.path ?? "/protocol",
    meta: indexnjfBdLeD65Meta || {},
    alias: indexnjfBdLeD65Meta?.alias || [],
    redirect: indexnjfBdLeD65Meta?.redirect || undefined,
    component: () => import("/ice/pages/protocol/index.vue").then(m => m.default || m)
  },
  {
    name: pointRulesxTAVnZraL7Meta?.name ?? "protocol-pointRules",
    path: pointRulesxTAVnZraL7Meta?.path ?? "/protocol/pointRules",
    meta: pointRulesxTAVnZraL7Meta || {},
    alias: pointRulesxTAVnZraL7Meta?.alias || [],
    redirect: pointRulesxTAVnZraL7Meta?.redirect || undefined,
    component: () => import("/ice/pages/protocol/pointRules.vue").then(m => m.default || m)
  },
  {
    name: protocolListG6naI9wu7LMeta?.name ?? "protocol-protocolList",
    path: protocolListG6naI9wu7LMeta?.path ?? "/protocol/protocolList",
    meta: protocolListG6naI9wu7LMeta || {},
    alias: protocolListG6naI9wu7LMeta?.alias || [],
    redirect: protocolListG6naI9wu7LMeta?.redirect || undefined,
    component: () => import("/ice/pages/protocol/protocolList.vue").then(m => m.default || m)
  }
]